import { NAME } from './constants';
import { State } from '../common/types/types';
import { AlertType } from './types';

export const getActiveAlert = (state: State): AlertType =>
  state[NAME].activeAlert;
export const isAlertVisible = (state: State): boolean =>
  state[NAME].alertVisible;
